import React, { useEffect, useState, useRef } from "react";
import logo from "../../Assets/img/logo.png";
import "./LoginPage.css";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../Redux/features/auth.slice";
import {
  Button,
  Checkbox,
  Form,
  Input,
  Spin,
  Row,
  notification,
  Modal,
  Progress,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import SpinFC from "antd/lib/spin";
import {
  sendResetPasswordEmail,
  confirmPasswordAndCode,
} from "../../API-Interaction/apiServices/logs.api";
import { auth } from "../../Utils/variables";
import { RightCircleFilled, edit, trash } from "../../Utils/imports";
import { cognitoLogin } from "../../API-Interaction/authService";
import { ErrorHandling } from "../../API-Interaction/errorHandling";
import { pageRoutes } from "../../Routing/pageRoutes";
import { antIcon } from "../../Helpers/helpers";
import { setLoader } from "../../Redux/features/utils.slice";
// import ForgotPassModal from "./ForgotPassModal";
import Loader from "../Helpers/Loader";
import ButtonComp from "../ButtonComp/ButtonComp";
import { BorderOuterOutlined } from "@ant-design/icons";
const { remember_me, heading, forgot_pass, no_acc, signup_text } = auth;

function LoginPage() {
  // SLIDER
  const [slideToggle, setslideToggle] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [forgotPassModal, setForgotPassModal] = useState(false);

  const ForgotPassModal = () => {
    const formRef = useRef(null);
    const { componentLoaders } = useSelector((state) => state.utils.loaders);
    // current step
    const [newPassword, setNewPassword] = useState("");
    const [otp, setOtp] = useState("");
    const [email, setEmail] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [step, setStep] = useState(1);

    const handleSubmit = async (values, err) => {
      // event.preventDefault();
      console.log("Submitting form...");

      if (!err) {
        try {
          if (step === 1) {
            await formRef.current.validateFields();
            await sendResetPasswordEmail(values.email);
            notification.success({
              message:
                "Password reset code has been sent to the email. Please enter the code and new password.",
            });
            setStep(2);
          } else if (step === 2) {
            formRef.current
              .validateFields()
              .then(() => {
                setStep(3);
              })
              .catch((error) => {
                console.log("Form validation failed:", error);
              });
          } else if (step === 3) {
            console.log(`Confirm new password: ${email}`);
            console.log(`OTP: ${otp}`);
            console.log(`New password: ${newPassword}`);
    
            if (newPassword === confirmNewPassword) {
              setPasswordError("");
              setNewPassword("");
              setConfirmNewPassword("");
              setForgotPassModal(false);
              await confirmPasswordAndCode(email, otp, newPassword);
              notification.success({ message: "Password Reset Successful" });
              return;
            } else {
              setPasswordError("Password and Confirm Password do not match");
            }
          }
        } catch (err) {
          notification.error({ message: err.message });
        }
      }
    };

    const handleCloseModal = () => {
      setForgotPassModal(false);
      setStep(1);
    };

    return (
      <Modal
        title={<h2>Forgot Password</h2>}
        centered
        maskClosable={false}
        open={forgotPassModal}
        onCancel={handleCloseModal}
        footer={null}
        className="forgotPass"
      >
        <Spin
          indicator={antIcon}
          spinning={componentLoaders?.forgotPassModal || false}
        >
          <div>
            <h4
              style={{
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "0px",
              }}
            >{`Step ${step} of 3`}</h4>
            <div style={{ marginBottom: "20px" }}>
              <Progress
                percent={(step - 1) * 50 + 1}
                showInfo={false}
                strokeWidth={6}
                strokeColor="#1E6EFE"
              />
            </div>

            <Form
              form={form}
              name="forgotForm"
              className="forgotForm"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 24,
              }}
              initialValues={{
                remember: false,
              }}
              onFinish={handleSubmit}
              autoComplete="off"
              ref={formRef}
            >
              {step === 1 && (
                <div>
                  <h4>Enter your email</h4>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your email!",
                      },
                      {
                        type: "email",
                        message: "Please enter a valid email!",
                      },
                    ]}
                  >
                    <Input
                      className="boxBorderRad width100P"
                      placeholder="Email"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                    />
                  </Form.Item>
                </div>
              )}
              {step === 2 && (
                <div>
                  <h4>Enter OTP sent on email:</h4>
                  <Form.Item
                    name="otp"
                    rules={[
                      {
                        required: true,
                        message: "Please enter an OTP!",
                      },
                    ]}
                  >
                    <Input
                      className="boxBorderRad width100P"
                      value={otp}
                      onChange={(event) => setOtp(event.target.value)}
                    />
                  </Form.Item>
                </div>
              )}
              {step === 3 && (
                <div>
                  <h4>New Password:</h4>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter New Password",
                      },
                    ]}
                  >
                    <Input
                      className="boxBorderRad width100P"
                      type="password"
                      id="new-password"
                      value={newPassword}
                      onChange={(event) => setNewPassword(event.target.value)}
                    />
                  </Form.Item>
                  <h4>Confirm Password:</h4>
                  <Form.Item
                    name="confirm"
                    rules={[
                      {
                        required: true,
                        message: "Please Re-enter Password",
                      },
                    ]}
                  >
                    <Input
                      className="boxBorderRad width100P"
                      type="password"
                      id="confirm-new-password"
                      value={confirmNewPassword}
                      onChange={(event) =>
                        setConfirmNewPassword(event.target.value)
                      }
                    />
                  </Form.Item>
                  {passwordError && (
                    <Form.Item>
                      <div style={{ color: "red" }}>{passwordError}</div>
                    </Form.Item>
                  )}
                </div>
              )}
              <Row className="dflex alignCenter justifyCenter gap10">
                <Form.Item className="width100P dflex alignCenter justifyFE">
                  <ButtonComp
                    className="btnBlue"
                    style={{ width: "100px" }}
                    theme="blue"
                    htmlType="submit"
                    text="Next"
                    icon={<RightCircleFilled />}
                  />
                </Form.Item>
              </Row>
            </Form>
          </div>
        </Spin>
      </Modal>
    );
  };

  const SliderToggleBtns = () => {
    return (
      <div className="Login_slider_togglebtns_container">
        <button
          className={
            slideToggle === 1
              ? "Login_slide_togglebtn_active"
              : "Login_slide_togglebtn"
          }
          onClick={() => setslideToggle(1)}
        ></button>
        <button
          className={
            slideToggle === 2
              ? "Login_slide_togglebtn_active"
              : "Login_slide_togglebtn"
          }
          onClick={() => setslideToggle(2)}
        ></button>
        <button
          className={
            slideToggle === 3
              ? "Login_slide_togglebtn_active"
              : "Login_slide_togglebtn"
          }
          onClick={() => setslideToggle(3)}
        ></button>
      </div>
    );
  };

  const Slide1 = () => {
    return (
      <div className="Login_slide1">
        <p>
          Eliminate downtime and improve productivity with Procheck's IoT
          platform.
        </p>
        <h1>
          Leading the digital <br /> transformation of <br />
          manufacturing plants.
        </h1>
        <SliderToggleBtns />
      </div>
    );
  };
  const Slide2 = () => {
    return (
      <div className="Login_slide2">
        <p>
          Eliminate downtime and improve productivity with Procheck's IoT
          platform.
        </p>
        <h1>
          Leading the digital <br /> transformation of <br />
          manufacturing plants.
        </h1>
        <SliderToggleBtns />
      </div>
    );
  };
  const Slide3 = () => {
    return (
      <div className="Login_slide3">
        <p>
          Eliminate downtime and improve productivity with Procheck's IoT
          platform.
        </p>
        <h1>
          Leading the digital <br /> transformation of <br />
          manufacturing plants.
        </h1>
        <SliderToggleBtns />
      </div>
    );
  };
  const ShowSlide = () => {
    if (slideToggle === 1) return <Slide1 />;
    if (slideToggle === 2) return <Slide2 />;
    if (slideToggle === 3) return <Slide3 />;
  };

  // LOGIN

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pageLoaders } = useSelector((state) => state.utils.loaders);

  useEffect(() => {
    localStorage.clear();
  }, []);

  const onFinish = async (values) => {
    let { username, password } = values;
    setIsLoading(true);
    await cognitoLogin({ username, password }, dispatch, navigate);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="LoginMain">
      <div className="Login_left">
        <img src={logo} alt="logo" className="logo" />
        <ShowSlide />
      </div>
      <div className="Login_right">
        <Loader loading={pageLoaders?.login || false}>
          <div className="LoginFormContainer">
            <h1>{heading}</h1>
            <Form
              name="loginForm"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 24,
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              className="loginForm"
            >
              <Form.Item
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Please enter your email!",
                  },
                ]}
              >
                <Input className="loginInputs" placeholder="Email" />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your password!",
                  },
                ]}
              >
                <Input.Password
                  className="loginInputs"
                  placeholder="Password"
                />
              </Form.Item>

              <Form.Item
                name="remember"
                valuePropName="checked"
                wrapperCol={{
                  offset: 0,
                  span: 24,
                }}
              >
                <Checkbox>{remember_me}</Checkbox>
              </Form.Item>

              <Form.Item
                wrapperCol={{
                  offset: 0,
                  span: 24,
                }}
              >
                <Button htmlType="submit" className="submit">
                  {heading}
                </Button>
              </Form.Item>
            </Form>
            <div className="loginForm">
              <Button
                className="forgotPassword"
                onClick={() => {
                  form.resetFields();
                  setForgotPassModal(true);
                }}
                theme="white"
              >
                Forgot Password
              </Button>{" "}
              <ForgotPassModal />
            </div>
          </div>
        </Loader>
        <div className="dontHaveAnAccount dflex alignCenter justifyCenter">
          {/* <p>{no_acc}</p> */}
          {/* <span>{signup_text}</span> */}
        </div>
      </div>
    </div>
  );
}

export default LoginPage;